import { ChunkLoadErrorPage, isChunkLoadError } from "@/app/routes/ChunkLoadErrorPage.tsx";
import { NotFoundErrorPage } from "@/app/routes/NotFoundErrorPage.tsx";
import { UnexpectedErrorPage } from "@/app/routes/UnexpectedErrorPage.tsx";
import { AppLoading } from "@/components/ui/app-loading/AppLoading.tsx";
import { useEnvironmentVariables } from "@workleap-ai/shared";
import { isApiError } from "@workleap-ai/shared/http";
import { useRouteError } from "react-router";

export const ErrorBoundary = () => {
    const error = useRouteError();
    const { loginPageUrl } = useEnvironmentVariables();

    if (isApiError(error)) {
        const { status } = error;

        // If the user is not authenticated, redirect to the login page
        if (status === 401) {
            const returnUrl = new URLSearchParams({ returnUrl: window.location.href });
            window.location.href = `${loginPageUrl}?${returnUrl}`;

            return <AppLoading />;
        }

        if (status === 404) {
            return <NotFoundErrorPage />;
        }
    }

    if (isChunkLoadError(error)) {
        return <ChunkLoadErrorPage />;
    }

    return <UnexpectedErrorPage />;
};
